import { GetDayOfWeek } from '@/api/bff_types';
import { DayOfWeekType } from '@/@types/dayofweek';

export const parseDayOfWeek = (
  data?: GetDayOfWeek
): DayOfWeekType | undefined => {
  return DayOfWeekType[data?.dayOfWeek as keyof typeof DayOfWeekType] || undefined;
};